const ids = (observation) => [observation?._id, observation?.id, observation?._clientId]
  .filter((id) => id !== undefined && id !== null && id !== "")
  .map(String)

export const matchesObservationUpdate = (existing, incoming, requestedId) => {
  const targetIds = new Set([...ids(incoming), ...ids({ _id: requestedId })])
  return ids(existing).some((id) => targetIds.has(id))
}

// Preserve list order and local fields, replacing only the requested record.
// Collapse any copies of that same observation left by older update logic.
export const reconcileObservationUpdate = (observations = [], incoming, requestedId) => {
  const result = []
  let matched = false
  for (const observation of observations) {
    if (!matchesObservationUpdate(observation, incoming, requestedId)) {
      result.push(observation)
    } else if (!matched) {
      result.push({ ...observation, ...incoming })
      matched = true
    }
  }
  if (!matched) result.unshift(incoming)
  return result
}
